module.exports = __webpack_public_path__ + "img/taishi_cut.ecdd04b5.png";